import React from "react"

import { css } from "@emotion/react"
import { Tooltip } from "antd"
import type { TooltipPlacement } from "antd/lib/tooltip"

import type { AvailableTextTypography } from "@front-shared/types/elements.types.ts"

import { NIRVANA_COLORS } from "../config/theme.config.ts"
import { PrimaryText } from "./primaryText.element"

import tooltipAlertIcon from "@front-shared/assets/images/elements/tooltip/tooltip-alert.svg"
import tooltipIcon from "@front-shared/assets/images/elements/tooltip/tooltip.svg"

export const TooltipElement: React.FunctionComponent<
    ITooltipElementProps
> = props => {
    return !props.disabled || props.inlineLabel ? (
        <div
            css={[
                styles.container,
                !props.isInlined && !props.inlineLabel
                    ? styles.containerWidthIcon
                    : undefined,
            ]}
            className={`
                ${props.className}
                ${props.isInlined ? "inline-block" : ""}
            `}
        >
            <Tooltip
                color={
                    props.backgroundColor ||
                    (typeof props.text === "string"
                        ? NIRVANA_COLORS.brand.black
                        : "transparent")
                }
                placement={props.placement || "bottom"}
                title={
                    typeof props.text === "string" ? (
                        <PrimaryText
                            typography="text"
                            centered
                            color={NIRVANA_COLORS.brand.white}
                        >
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: props.text,
                                }}
                            />
                        </PrimaryText>
                    ) : (
                        props.text
                    )
                }
            >
                {props.inlineLabel ? (
                    <div>
                        <PrimaryText
                            typography={
                                props.inlineLabelTypography || "inherit"
                            }
                        >
                            {props.inlineLabel}

                            {!props.disabled ? (
                                <div css={styles.inlineUnderline} />
                            ) : null}
                        </PrimaryText>
                    </div>
                ) : !props.disabled ? (
                    <div>
                        <img
                            src={props.isAlert ? tooltipAlertIcon : tooltipIcon}
                            alt="Tooltip"
                        />
                    </div>
                ) : null}
            </Tooltip>
        </div>
    ) : null
}

const styles = {
    container: css({
        position: "relative",
        cursor: "help",
    }),
    containerWidthIcon: css({
        width: 16,
    }),
    inlineUnderline: css({
        position: "absolute",
        width: "100%",
        bottom: 0,
        opacity: 0.75,
        border: `1px dashed ${NIRVANA_COLORS.brand.primary}`,
    }),
}

interface ITooltipElementProps {
    className?: string
    disabled?: boolean
    isAlert?: boolean
    // TODO it would make sense to rename this prop
    // Since it accepts Element now
    // But it would require renaming it in all projects in all places
    text: string | React.JSX.Element
    isInlined?: boolean
    inlineLabel?: string
    inlineLabelTypography?: AvailableTextTypography
    backgroundColor?: string
    placement?: TooltipPlacement
}
